// import React, { useState, useEffect } from "react";
// import { getLoggedInUser } from "../helpers";
// import { Container, Row, Col, Alert } from "reactstrap";
// import { AvForm, AvField } from "availity-reactstrap-validation";
// import { betSlipService } from "../redux/betslip/services";
// import swal from "sweetalert";
// import PreLoaderWidget from "../components/League";
// import config from "react-global-configuration";
// import { Button } from "reactstrap";
// import crypto3 from "../assets/images/withdraw/crypto3.png";
// import Group3 from "../assets/images/withdraw/Group3.png";
// import Visa from "../assets/images/withdraw/Visa.png";
// import { useTranslation } from "react-i18next";
// const WithdrawRequests = ({ setIsModalOpen, ...props }) => {
//   const [user, setUser] = useState(getLoggedInUser());
//   const [userList, setUserList] = useState({});
//   const [paymentMethodsData, setPaymentMethods] = useState({});
//   const { t } = useTranslation();
//   const [paymentMethodFileds, setPaymentMethodFileds] = useState([]);
//   const [isLoading, setIsLoading] = useState(false);
//   const [paymentFields, setPaymentFields] = useState([]);
//   const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");
//   const [selectedMethod, setSelectedMethod] = useState("");
//   const [open, setOpen] = useState(false);

//   const withdrawImages = [
//     { id: 1, src: crypto3, name: "Crypto", alt: "Crypto" },
//     // { id: 1, src: Group3, name: "apcopay", alt: "Credit Card" },
//     // { id: 2, src: crypto3, name: "bridgerpay", alt: "crypto" },

//   ]

//   const cryptoOptions = [
//     { code: "USDC.ERC20", name: "USDC" },
//     { code: "BTC", name: "Bitcoin" },
//     { code: "ETH", name: "Ethereum" },
//     { code: "SOL", name: "Solana" },
//     { code: "DOGE", name: "Dogecoin" },
//     { code: "XRP", name: "Ripple" },
//     { code: "LTCT", name: "LTCT" }
//   ];
//    const [currency, setCurrency] = useState("");

//   useEffect(() => {
//     loadRecordsTables();
//   }, []);

//   const loadRecordsTables = () => {
//     const reqData = { guid: user.guid };
//     console.log(user);
//     setIsLoading(true);
//     betSlipService.fatchUserDetails(reqData).then((res) => {
//       let data = res?.data;
//       setIsLoading(false);
//       setUserList(data);
//       console.log("test", data);
//     });
//   };

//   // const loadPaymentMethods = () => {
//   //   const reqData = { country: userList.country };
//   //   setIsLoading(true);
//   //   betSlipService.fatchgetPaymentMethods(reqData).then((res) => {
//   //     let data = res;
//   //     setPaymentMethods(data.data);

//   //     console.log("loadPaymentMethods", data.data);
//   //     setIsLoading(false);
//   //   });
//   // };

//   // useEffect(() => {
//   //   if (selectedPaymentMethod && selectedPaymentMethod.length > 0) {
//   //     fieldsPaymentMethods();
//   //   }
//   // }, [selectedPaymentMethod]);

//   // const fieldsPaymentMethods = () => {
//   //   const reqData = {
//   //     country: userList.country,
//   //     paymentMethod: selectedPaymentMethod,
//   //   };
//   //   setIsLoading(true);

//   //   betSlipService.getFieldsPaymentMethods(reqData).then((res) => {
//   //     let data = res;
//   //     console.log("fieldsPaymentMethods", data);
//   //     setPaymentFields(data.fields || []);

//   //     setIsLoading(false);
//   //   });
//   // };

//   //

//   // useEffect(() => {
//   //   if (selectedMethod) {
//   //     loadPaymentMethods();
//   //   }
//   // }, [selectedMethod]);

//   // const loadPaymentMethods = () => {
//   //   const reqData = {
//   //     country: userList.country,
//   //     type: selectedMethod,
//   //   };
//   //   setIsLoading(true);
//   //   betSlipService.fatchgetPaymentMethods(reqData).then((res) => {
//   //     let data = res;
//   //     setPaymentMethods(data.data);

//   //     console.log("loadPaymentMethods", data.data);
//   //     setIsLoading(false);
//   //   });
//   // };

//   // const handleMethodSelect = (methodType) => {
//   //   setSelectedMethod(methodType);
//   //   setPaymentMethodsData(PAYMENT_LIST[methodType] || []);
//   // };

//   const handleValidSubmit = (event, values) => {
//     setIsLoading(true);

//     swal({
//       text: "You have Bonus Funds in your account. Requesting a Withdrawal will forfeit these funds. Do you wish to proceed?",
//       icon: "warning",
//       buttons: {
//         cancel: "No",
//         confirm: "Yes",
//       },
//       successMode: true,
//     }).then((result) => {
//       if (result) {
//         setIsModalOpen(false); // ✅ Close modal right after confirmation

//         let formData = new FormData();
//         formData.append("user_id", values.user_id);
//         formData.append("amount", values.amount);
//         formData.append("cryptoAddress", values.cryptoAddress || "");
//         formData.append("paymentMethod", values.paymentMethod);
//         formData.append("country", userList?.country);
//         formData.append("currency", currency);
//         formData.append("guid", user?.guid || "");
//         formData.append("first_name", userList?.first_name || "");
//         formData.append("last_name", userList?.last_name || "");
//         // formData.append("email", userList?.email || "");

//         paymentFields.forEach((field) => {
//           if (values[field.name] !== undefined) {
//             formData.append(field.name, values[field.name]);
//           }
//         });

//         betSlipService
//           .useApcoPayPayout(formData, config)
//           .then((response) => {
//             console.log("API Response:", response);
//             setIsLoading(false);

//             const resultStatus = response?.payout_response?.result?.status;

//             if (resultStatus === "Declined") {
//               swal({
//                 title: "Withdrawal Declined",
//                 text: "Your withdrawal request is declined.",
//                 icon: "error",
//                 buttons: { confirm: "Ok" },
//               });
//             } else if (
//               resultStatus === "Approved" ||
//               resultStatus === "Success" ||
//               resultStatus === "Submitted"
//             ) {
//               swal({
//                 title: "Success",
//                 text: "Your withdrawal request submitted successfully.",
//                 icon: "success",
//                 buttons: { confirm: "Ok" },
//               }).then((result) => {
//                 if (result) {
//                   window.location.href = "/user-profile";
//                 }
//               });
//             } else {
//               const noticeMessage =
//                 response?.payout_response?.result?.status === "Error"
//                   ? response?.payout_response?.result?.message
//                   : response?.message || "Please try again.";

//               swal({
//                 // title: "Error",
//                 text: noticeMessage,
//                 icon: "error",
//                 buttons: { confirm: "Ok" },
//               });
//             }
//           })
//           .catch((error) => {
//             setIsLoading(false);
//             console.error("API Error:", error);
//             const errorMessage =
//               error.response?.data?.message ||
//               "An error occurred. Please try again later.";
//             swal(errorMessage, { icon: "error" });
//           });
//       }
//     });
//     setIsLoading(false);
//   };

//   return (
//     <React.Fragment>
//       {props.loading && <PreLoaderWidget />}
//       {props.error && (
//         <Alert color="danger" isOpen={!!props.error}>
//           <div dangerouslySetInnerHTML={{ __html: props.error }}></div>
//         </Alert>
//       )}
//       <div className="account-pages">
//         <section>
//           <Container>
//             <Row className="justify-content-center">
//               <Col className="col-xl-12">
//                 <div className="card--body">
//                   <AvForm onValidSubmit={handleValidSubmit}>
//                     <div className="gy-3">
//                       <div className="col-md-12">
//                         <h3
//                           style={{ textAlign: "center" }}
//                           className="text-white"
//                         >
//                           {t('userProfile.withdrawPop.title')}
//                         </h3>
//                       </div>
//                       <div className="col-md-12">
//                         <h5
//                           style={{ textAlign: "center" }}
//                           className="text-white"
//                         >
//                           {t('userProfile.withdrawPop.totalCashBalance')} :{" "}
//                           {userList.total_cash_balance ? "€" : "0.00"}
//                           {userList.total_cash_balance}
//                         </h5>
//                       </div>

//                       <AvField
//                         type="hidden"
//                         name="user_id"
//                         id="user_id"
//                         className="mb-0"
//                         value={userList.id || ""}
//                       />
//                       {isLoading && (
//                         <div className="loader">{t('userProfile.withdrawPop.loading')}</div>
//                       )}

//                       {/* start */}

//                       <div style={{
//                         marginBottom: "10px"
//                       }}>
//                         {t("userProfile.withdrawPop.selectedMethod")} : {selectedMethod.alt}
//                       </div>
//                       <div className="payment-grid mb-3">
//                         {withdrawImages.map((method) => (
//                           <div
//                             key={method.id}
//                             onClick={() => setSelectedMethod(method.name)}
//                             className=
//                             {`payment-card ${selectedMethod === method.name ? "active" : ""}`}

//                           >
//                             <img
//                               src={method.src}
//                               alt={method.alt}
//                               name={method.name}

//                             />
//                             <span>{method.alt}</span>
//                           </div>
//                         ))}
//                       </div>

//                       {selectedMethod && (
//                         <AvField
//                           type="select"
//                           name="paymentMethod"
//                           required
//                           className="form-controll form--control2 style-two"
//                           errorMessage={t("userProfile.withdrawPop.pleaseSelect")}
//                           onChange={(e) => setSelectedPaymentMethod(e.target.value)}
//                         >
//                           <option value="">
//                             -- {t("userProfile.withdrawPop.selectMethod")} --
//                           </option>

//                           <option value="Crypto">CRYPTO</option>
//                         </AvField>
//                       )}

//                       {/* <AvField
//                         type="select"
//                         name="paymentMethod"
//                         required
//                         className="form-controll form--control2 style-two"
//                         errorMessage={t("userProfile.withdrawPop.pleaseSelect")}
//                         onChange={(e) => setSelectedPaymentMethod(e.target.value)}
//                       >
//                           <option value="">-- {t("userProfile.withdrawPop.selectMethod")}  --</option>

//                         <option value="Crypto">CRYPTO</option>
//                       </AvField>  */}

//                       {/* end */}

//                       {/* {paymentMethodsData?.length > 0 && (
//                         <AvField
//                           type="select"
//                           name="paymentMethod"
//                           label={t("userProfile.withdrawPop.paymentMethod")}
//                           required
//                           className="form-controll form--control2 style-two"
//                           errorMessage={t("userProfile.withdrawPop.pleaseSelect")}
//                           onChange={(e) =>
//                             setSelectedPaymentMethod(e.target.value)
//                           }
//                         >
//                           <option value="">-- {t("userProfile.withdrawPop.selectMethod")}  --</option>
//                           {paymentMethodsData.map((method) => (
//                             <option key={method} value={method}>
//                               {method.replace(/_/g, " ").toUpperCase()}
//                             </option>
//                           ))}
//                         </AvField>
//                       )} */}

//                       {paymentMethodsData?.length > 0 && (
//                         <AvField
//                           type="select"
//                           name="paymentMethod"
//                           label="Select Payment Method"
//                           required
//                           className="form-controll form--control2 style-two"
//                           errorMessage="Please select"
//                           onChange={(e) => setSelectedPaymentMethod(e.target.value)}
//                         >
//                           <option value="">-- Select Payment Method --</option>

//                           {paymentMethodsData.map((method) => (
//                             <option key={method} value={method}>
//                               {method.replace(/_/g, " ").toUpperCase()}
//                             </option>
//                           ))}
//                         </AvField>
//                       )}

//                       {selectedPaymentMethod &&
//                         paymentFields.map((field, index) => {
//                           const isRequired = field.required;
//                           const fieldName = field.name;
//                           const fieldTitle = field.title;
//                           const controlType = field.control_type;
//                           const label = (
//                             <label
//                               htmlFor={fieldName}
//                               className="form-label text-white"
//                             >
//                               {fieldTitle}
//                               {/* {isRequired && (
//                                     <span className="required text-danger">*</span>
//                             )} */}
//                             </label>
//                           );

//                           if (controlType === "input") {
//                             return (
//                               <div className="col-md-12" key={index}>
//                                 <div className="form-group">
//                                   {label}
//                                   <AvField
//                                     id={fieldName}
//                                     type="text"
//                                     name={fieldName}
//                                     className="form-control form--control2 style-two"
//                                     placeholder={`Enter ${fieldTitle.toLowerCase()}`}
//                                     required={isRequired}
//                                     errorMessage={`Please enter ${fieldTitle.toLowerCase()}.`}
//                                   />
//                                 </div>
//                               </div>
//                             );
//                           }

//                           if (controlType === "email") {
//                             return (
//                               <div className="col-md-12" key={index}>
//                                 <div className="form-group">
//                                   {label}
//                                   <AvField
//                                     id={fieldName}
//                                     type="email"
//                                     name={fieldName}
//                                     className="form-control form--control2 style-two"
//                                     placeholder={`Enter ${fieldTitle.toLowerCase()}`}
//                                     required={isRequired}
//                                     errorMessage={`Please enter a valid email.`}
//                                   />
//                                 </div>
//                               </div>
//                             );
//                           }

//                           if (controlType === "select") {
//                             return (
//                               <div className="col-md-12" key={index}>
//                                 <div className="form-group">
//                                   {label}
//                                   <AvField
//                                     type="select"
//                                     name={fieldName}
//                                     id={fieldName}
//                                     className="form-controll form--control2 style-two"
//                                     required={isRequired}
//                                     errorMessage={`Please select ${fieldTitle.toLowerCase()}.`}
//                                   >
//                                     <option value="">-- Select --</option>
//                                     {field.items?.map((item, idx) => {
//                                       const value = item?.value || item;
//                                       const title = item?.title || item;
//                                       return (
//                                         <option key={idx} value={value}>
//                                           {title}
//                                         </option>
//                                       );
//                                     })}
//                                   </AvField>
//                                 </div>
//                               </div>
//                             );
//                           }

//                           return null;
//                         })}

//                       {selectedPaymentMethod === "Crypto" && (
//                         <>
//                         <div className="col-md-12">
//                           <div className="form-group">
//                             <label
//                               htmlFor="cryptoAddress"
//                               className="form-label text-white"
//                             >
//                               {t("userProfile.withdrawPop.crypto")}
//                             </label>

//                             <AvField
//                               id="cryptoAddress"
//                               type="text"
//                               className="form-control form--control2 style-two"
//                               name="cryptoAddress"
//                               placeholder={t("userProfile.withdrawPop.entercryptoaddress")}
//                               required
//                               errorMessage={t("userProfile.withdrawPop.pleaseEntercryptoaddress")}
//                             />
//                           </div>
//                         </div>

//                           <div style={{ marginTop: "10px" }}>
//                                     <label className="form-label text-white">Select Currency</label>
//                                     <select
//                                       className="form--controlc form-control style--two"
//                                       value={currency}
//                                       onChange={(e) => setCurrency(e.target.value)}

//                                     >
//                                       <option value="">Select Currency</option>
//                                       {cryptoOptions.map((c) => (
//                                         <option key={c.code} value={c.code}>
//                                           {c.name}
//                                         </option>
//                                       ))}
//                                     </select>

//                                   </div>
//                          </>

//                       )}

//                       {/* <div className="col-md-12">
//                         <div className="form-group">
//                           <label
//                             htmlFor="Crypto Address"
//                             className="form-label text-white"
//                           >
//                             {t("userProfile.withdrawPop.crypto")}  {" "}
//                             <span className="required text-danger">*</span>
//                           </label>
//                           <AvField
//                             id="cryptoAddress"
//                             type="text"
//                             className="form-control form--control2 style-two"
//                             name="cryptoAddress"
//                             placeholder={t("userProfile.withdrawPop.entercryptoaddress")}
//                             required
//                             errorMessage={t("userProfile.withdrawPop.pleaseEntercryptoaddress")}
//                           />
//                         </div>
//                       </div> */}

//                       <div className="col-md-12"  style={{ marginTop: "10px" }}>
//                         <div className="form-group">
//                           <label
//                             htmlFor="amount"
//                             className="form-label text-white"
//                           >
//                             {t("userProfile.withdrawPop.amount")}  {" "}
//                             {/* <span className="required text-danger">*</span> */}
//                           </label>
//                           <AvField
//                             id="amount"
//                             type="number"
//                             className="form-control form--control2 style-two"
//                             name="amount"
//                             placeholder={t("userProfile.withdrawPop.enterAmount")}
//                             required
//                             errorMessage={t("userProfile.withdrawPop.pleaseEnterAmount")}
//                           />
//                         </div>
//                       </div>
//                       <div className="col-md-12 mb-3 center">
//                         <button className="cstm_btn2 active ">
//                           {t('userProfile.withdrawPop.submit')}
//                         </button>
//                       </div>
//                     </div>
//                   </AvForm>
//                 </div>
//               </Col>
//             </Row>
//           </Container>
//         </section>
//       </div>
//     </React.Fragment>
//   );
// };

// export default WithdrawRequests;

import React, { useState, useEffect } from "react";
import { getLoggedInUser } from "../helpers";
import { Container, Row, Col, Alert } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { betSlipService } from "../redux/betslip/services";
import swal from "sweetalert";
import PreLoaderWidget from "../components/League";
import config from "react-global-configuration";
import { Button } from "reactstrap";
import crypto3 from "../assets/images/withdraw/crypto3.png";
import Group3 from "../assets/images/withdraw/Group3.png";
import Visa from "../assets/images/withdraw/Visa.png";
import { useTranslation } from "react-i18next";
const WithdrawRequests = ({ setIsModalOpen, ...props }) => {
  const [user, setUser] = useState(getLoggedInUser());
  const [userList, setUserList] = useState({});
  const [paymentMethodsData, setPaymentMethods] = useState({});
  const { t } = useTranslation();
  const [paymentMethodFileds, setPaymentMethodFileds] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [paymentFields, setPaymentFields] = useState([]);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");
  const [selectedMethod, setSelectedMethod] = useState("");
  const [open, setOpen] = useState(false);
  const [currency, setCurrency] = useState("");

  const withdrawImages = [
    { id: 1, src: Group3, name: "apcopay", alt: "Credit Card" },
    { id: 2, src: crypto3, name: "crypto", alt: "Crypto" },
  ];

  const cryptoOptions = [
    { code: "USDC.ERC20", name: "USDC.ERC20" },
    { code: "USDC", name: "USDC" },
    { code: "BTC", name: "Bitcoin" },
    { code: "ETH", name: "Ethereum" },
    { code: "SOL", name: "Solana" },
    { code: "DOGE", name: "Dogecoin" },
    { code: "XRP", name: "Ripple" },
  ];

  useEffect(() => {
    loadRecordsTables();
  }, []);

  const loadRecordsTables = () => {
    const reqData = { guid: user.guid };
    console.log(user);
    setIsLoading(true);
    betSlipService.fatchUserDetails(reqData).then((res) => {
      let data = res?.data;
      if (data?.status_id === 2 || data?.status_id === 4) {
        window.location.href = "/logout";
        return;
      }
      setIsLoading(false);
      setUserList(data);
      console.log("test", data);
    });
  };

  // const loadPaymentMethods = () => {
  //   const reqData = { country: userList.country };
  //   setIsLoading(true);
  //   betSlipService.fatchgetPaymentMethods(reqData).then((res) => {
  //     let data = res;
  //     setPaymentMethods(data.data);

  //     console.log("loadPaymentMethods", data.data);
  //     setIsLoading(false);
  //   });
  // };

  useEffect(() => {
    if (selectedPaymentMethod && selectedPaymentMethod.length > 0) {
      fieldsPaymentMethods();
    }
  }, [selectedPaymentMethod]);

  const fieldsPaymentMethods = () => {
    const reqData = {
      country: userList.country,
      paymentMethod: selectedPaymentMethod,
    };
    setIsLoading(true);

    betSlipService.getFieldsPaymentMethods(reqData).then((res) => {
      let data = res;
      console.log("fieldsPaymentMethods", data);
      setPaymentFields(data.fields || []);

      setIsLoading(false);
    });
  };

  useEffect(() => {
    if (selectedMethod) {
      loadPaymentMethods();
    }
  }, [selectedMethod]);

  const loadPaymentMethods = () => {
    const reqData = {
      country: userList.country,
      type: selectedMethod,
    };
    setIsLoading(true);
    betSlipService.fatchgetPaymentMethods(reqData).then((res) => {
      let data = res;
      setPaymentMethods(data.data);

      console.log("loadPaymentMethods", data.data);
      setIsLoading(false);
    });
  };

  // const handleMethodSelect = (methodType) => {
  //   setSelectedMethod(methodType);
  //   setPaymentMethodsData(PAYMENT_LIST[methodType] || []);
  // };

  const handleValidSubmit = (event, values) => {
    setIsLoading(true);

    swal({
      text: "You have Bonus Funds in your account. Requesting a Withdrawal will forfeit these funds. Do you wish to proceed?",
      icon: "warning",
      buttons: {
        cancel: "No",
        confirm: "Yes",
      },
      successMode: true,
    }).then((result) => {
      if (result) {
        setIsModalOpen(false); // ✅ Close modal right after confirmation

        let formData = new FormData();
        formData.append("user_id", values.user_id);
        formData.append("amount", values.amount);
        formData.append("cryptoAddress", values.cryptoAddress || "");
        formData.append("paymentMethod", selectedMethod);
        formData.append("country", userList?.country);
        // formData.append("currency", userList?.currency);
        formData.append("currency", currency);
        formData.append("guid", user?.guid || "");
        formData.append("first_name", userList?.first_name || "");
        formData.append("last_name", userList?.last_name || "");
        // formData.append("email", userList?.email || "");

        paymentFields.forEach((field) => {
          if (values[field.name] !== undefined) {
            formData.append(field.name, values[field.name]);
          }
        });

        betSlipService
          .useApcoPayPayout(formData, config)
          .then((response) => {
            console.log("API Response:", response);
            setIsLoading(false);

            const resultStatus = response?.payout_response?.result?.status;

            if (resultStatus === "Declined") {
              swal({
                title: "Withdrawal Declined",
                text: "Your withdrawal request is declined.",
                icon: "error",
                buttons: { confirm: "Ok" },
              });
            } else if (
              resultStatus === "Approved" ||
              resultStatus === "Success" ||
              resultStatus === "Submitted"
            ) {
              swal({
                title: "Success",
                text: "Your withdrawal request submitted successfully.",
                icon: "success",
                buttons: { confirm: "Ok" },
              }).then((result) => {
                if (result) {
                  window.location.href = "/user-profile";
                }
              });
            } else {
              const noticeMessage =
                response?.payout_response?.result?.status === "Error"
                  ? response?.payout_response?.result?.message
                  : response?.message || "Please try again.";

              swal({
                // title: "Error",
                text: noticeMessage,
                icon: "error",
                buttons: { confirm: "Ok" },
              });
            }
          })
          .catch((error) => {
            setIsLoading(false);
            console.error("API Error:", error);
            const errorMessage =
              error.response?.data?.message ||
              "An error occurred. Please try again later.";
            swal(errorMessage, { icon: "error" });
          });
      }
    });
    setIsLoading(false);
  };

  return (
    <React.Fragment>
      {props.loading && <PreLoaderWidget />}
      {props.error && (
        <Alert color="danger" isOpen={!!props.error}>
          <div dangerouslySetInnerHTML={{ __html: props.error }}></div>
        </Alert>
      )}
      <div className="account-pages">
        <section>
          <Container>
            <Row className="justify-content-center">
              <Col className="col-xl-12">
                <div className="card--body">
                  <AvForm onValidSubmit={handleValidSubmit}>
                    <div className="gy-3">
                      <div className="col-md-12">
                        <h3
                          style={{ textAlign: "center" }}
                          className="text-white"
                        >
                          {t("userProfile.withdrawPop.title")}
                        </h3>
                      </div>
                      <div className="col-md-12">
                        <h5
                          style={{ textAlign: "center" }}
                          className="text-white"
                        >
                          {t("userProfile.withdrawPop.totalCashBalance")} :{" "}
                          &nbsp;
                          {`€ ${Number(userList.total_cash_balance).toFixed(2)}`}
                        </h5>
                      </div>

                      <AvField
                        type="hidden"
                        name="user_id"
                        id="user_id"
                        className="mb-0"
                        value={userList.id || ""}
                      />
                      {isLoading && (
                        <div className="loader">
                          {t("userProfile.withdrawPop.loading")}
                        </div>
                      )}

                      {/* start */}

                      <div style={{ marginTop: "20px" }}>
                        {t("userProfile.withdrawPop.selectedMethod")} :{" "}
                        {selectedMethod.alt}
                      </div>
                      <div className="payment-grid">
                        {withdrawImages.map((method) => (
                          <div
                            key={method.id}
                            onClick={() => setSelectedMethod(method.name)}
                            className={`payment-card ${selectedMethod === method.name ? "active" : ""}`}
                          >
                            <img
                              src={method.src}
                              alt={method.alt}
                              name={method.name}
                            />
                            <span>{method.alt}</span>
                          </div>
                        ))}
                      </div>

                      {/* end */}

                      <div style={{ marginTop: "20px" }}>
                        {paymentMethodsData?.length > 0 && (
                          <AvField
                            type="select"
                            name="paymentMethod"
                            label={t("userProfile.withdrawPop.paymentMethod")}
                            required
                            className="form--controlc form-control style--two"
                            errorMessage={t(
                              "userProfile.withdrawPop.pleaseSelect",
                            )}
                            onChange={(e) =>
                              setSelectedPaymentMethod(e.target.value)
                            }
                          >
                            <option value="">
                              -- {t("userProfile.withdrawPop.selectMethod")} --
                            </option>
                            {paymentMethodsData.map((method) => (
                              <option key={method} value={method}>
                                {method.replace(/_/g, " ").toUpperCase()}
                              </option>
                            ))}
                          </AvField>
                        )}
                      </div>

                      {selectedPaymentMethod &&
                        selectedMethod === "apcopay" &&
                        paymentFields.map((field, index) => {
                          const isRequired = field.required;
                          const fieldName = field.name;
                          const fieldTitle = field.title;
                          const controlType = field.control_type;
                          const label = (
                            <label
                              htmlFor={fieldName}
                              className="form-label text-white"
                            >
                              {fieldTitle}
                              {/* {isRequired && (
                                    <span className="required text-danger">*</span>
                            )} */}
                            </label>
                          );

                          if (controlType === "input") {
                            return (
                              <div className="col-md-12" key={index}>
                                <div className="form-group">
                                  {label}
                                  <AvField
                                    id={fieldName}
                                    type="text"
                                    name={fieldName}
                                    className="form-control form--control2 style-two"
                                    placeholder={`Enter ${fieldTitle.toLowerCase()}`}
                                    required={isRequired}
                                    errorMessage={`Please enter ${fieldTitle.toLowerCase()}.`}
                                  />
                                </div>
                              </div>
                            );
                          }

                          if (controlType === "email") {
                            return (
                              <div className="col-md-12" key={index}>
                                <div className="form-group">
                                  {label}
                                  <AvField
                                    id={fieldName}
                                    type="email"
                                    name={fieldName}
                                    className="form-control form--control2 style-two"
                                    placeholder={`Enter ${fieldTitle.toLowerCase()}`}
                                    required={isRequired}
                                    errorMessage={`Please enter a valid email.`}
                                  />
                                </div>
                              </div>
                            );
                          }

                          if (controlType === "select") {
                            return (
                              <div className="col-md-12" key={index}>
                                <div className="form-group">
                                  {label}
                                  <AvField
                                    type="select"
                                    name={fieldName}
                                    id={fieldName}
                                    className="form-controll form--control2 style-two"
                                    required={isRequired}
                                    errorMessage={`Please select ${fieldTitle.toLowerCase()}.`}
                                  >
                                    <option value="">-- Select --</option>
                                    {field.items?.map((item, idx) => {
                                      const value = item?.value || item;
                                      const title = item?.title || item;
                                      return (
                                        <option key={idx} value={value}>
                                          {title}
                                        </option>
                                      );
                                    })}
                                  </AvField>
                                </div>
                              </div>
                            );
                          }

                          return null;
                        })}

                      {selectedMethod === "crypto" && (
                        <>
                          <div className="col-md-12">
                            <div className="form-group">
                              <label
                                htmlFor="Crypto Address"
                                className="form-label text-white"
                              >
                                {t("userProfile.withdrawPop.crypto")}{" "}
                              </label>
                              <AvField
                                id="cryptoAddress"
                                type="text"
                                className="form-control form--control2 style-two"
                                name="cryptoAddress"
                                placeholder={t(
                                  "userProfile.withdrawPop.entercryptoaddress",
                                )}
                                required
                                errorMessage={t(
                                  "userProfile.withdrawPop.pleaseEntercryptoaddress",
                                )}
                              />
                            </div>
                          </div>
                          <div style={{ marginTop: "10px" }}>
                            <label className="form-label text-white">
                              Select Currency
                            </label>
                            <select
                              className="form--controlc form-control style--two"
                              value={currency}
                              onChange={(e) => setCurrency(e.target.value)}
                            >
                              <option value="">Select Currency</option>
                              {cryptoOptions.map((c) => (
                                <option key={c.code} value={c.code}>
                                  {c.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </>
                      )}

                      <div
                        className="col-md-12  "
                        style={{ marginTop: "10px" }}
                      >
                        <div className="form-group">
                          <label
                            htmlFor="amount"
                            className="form-label text-white"
                          >
                            {t("userProfile.withdrawPop.amount")}{" "}
                            {/* <span className="required text-danger">*</span> */}
                          </label>
                          <AvField
                            id="amount"
                            type="number"
                            className="form-control form--control2 style-two"
                            name="amount"
                            placeholder={t(
                              "userProfile.withdrawPop.enterAmount",
                            )}
                            required
                            errorMessage={t(
                              "userProfile.withdrawPop.pleaseEnterAmount",
                            )}
                          />
                        </div>
                      </div>
                      <div className="col-md-12 mb-3 center">
                        <button className="cstm_btn2 active ">
                          {t("userProfile.withdrawPop.submit")}
                        </button>
                      </div>
                    </div>
                  </AvForm>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
    </React.Fragment>
  );
};

export default WithdrawRequests;
